const firebaseConfig = {
  apiKey: "AIzaSyCmx7UwzE_CBLv0wyfRRHbNZfF7Dg6aCZc",
  authDomain: "travel-guru-website.firebaseapp.com",
  databaseURL: "https://travel-guru-website.firebaseio.com",
  projectId: "travel-guru-website",
  storageBucket: "travel-guru-website.appspot.com",
  messagingSenderId: "674355236157",
  appId: "1:674355236157:web:77c275abda8c7eaf764954",
};

export default firebaseConfig;
